export const SET_STORAGES = 'SET_STORAGES';
export const SET_STORAGE = 'SET_STORAGE';
export const ADD_STORAGE = 'ADD_STORAGE';
export const UPDATE_STORAGE = 'UPDATE_STORAGE';
export const REMOVE_STORAGE = 'REMOVE_STORAGE';
export const CLEAR_STORAGE = 'CLEAR_STORAGE';
export const CLEAR_STORAGES = 'CLEAR_STORAGES';
